/* Appstle's cart-page integration rewrites the theme's PER-ITEM price (.price__current in
   .cart-item__total) to the LINE TOTAL (qty x price) during its startup, including a late
   re-render that replaces the whole <cart-items> element — only on the /cart page, not the
   drawer. The theme deliberately shows per-item (snippets/cart-items.liquid).

   We cache the correct per-item prices from the theme's OWN section render and re-assert them.
   Notes learned the hard way:
   - Get the section name from the DOM section wrapper id, NOT cart-items.getSectionsToRender():
     this script is deferred and the <cart-items> custom element often isn't upgraded yet, so
     that method is undefined at load and the cache never populated.
   - Observe document.body (Appstle replaces the <cart-items> element, detaching an observer
     bound to it) + a short polling interval as insurance against timing races.
   - Appstle doesn't revert our writes and apply() only touches mismatches, so no ping-pong. */
(function () {
  if (!/\/cart\/?$/.test(location.pathname)) return; // cart page only

  function sectionName() {
    var el = document.querySelector('.cart-item__total');
    el = el && el.closest('[id^="shopify-section-"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  var cacheHTML = [];
  var cacheText = [];
  function fetchCache(cb) {
    var secName = sectionName();
    if (!secName) return;
    fetch('?sections=' + encodeURIComponent(secName))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[secName];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var good = tmp.querySelectorAll('.cart-item__total .price__current');
        cacheHTML = [];
        cacheText = [];
        for (var i = 0; i < good.length; i++) {
          cacheHTML.push(good[i].innerHTML);
          cacheText.push(good[i].textContent.trim());
        }
        if (cb) cb();
      })
      .catch(function () {});
  }

  function apply() {
    if (!cacheHTML.length) return;
    var live = document.querySelectorAll('.cart-item__total .price__current');
    for (var i = 0; i < live.length && i < cacheHTML.length; i++) {
      if (live[i].textContent.trim() !== cacheText[i]) live[i].innerHTML = cacheHTML[i];
    }
  }

  var raf = false;
  function schedule() {
    if (raf) return;
    raf = true;
    requestAnimationFrame(function () { raf = false; apply(); });
  }

  function start() {
    if (!document.querySelector('.cart-item__total')) return; // empty cart
    fetchCache(apply);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    // Insurance against startup timing races (Appstle writes at variable, sometimes late times).
    var ticks = 0;
    var iv = setInterval(function () { apply(); if (++ticks > 40) clearInterval(iv); }, 400); // ~16s
    document.addEventListener('on:cart:change', function () { setTimeout(function () { fetchCache(apply); }, 300); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
